import FormButton, { Button } from "./Button";
import FormCheckbox, { Checkbox, CheckboxLabel } from "./Checkbox";
import Form, { FormGroup, FormStatic } from "./Form";
import FormInput, { Input } from "./Input";
import FormRadio, { Radio, RadioLabel } from "./Radio";

export {
  Button,
  Checkbox,
  CheckboxLabel,
  FormButton,
  FormCheckbox,
  FormGroup,
  FormInput,
  FormRadio,
  FormStatic,
  Input,
  Radio,
  RadioLabel,
};
export default Form;
